import React from "react";
import CosecHeader from "@/components/cosec/Header";
import Hero from "@/components/cosec/Hero";
import TrustedBy from "@/components/cosec/TrustedBy";
import UnifiedPlatform from "@/components/cosec/UnifiedPlatform";
import Personas from "@/components/cosec/Personas";
import ProductsPortfolio from "@/components/cosec/ProductsPortfolio";
import PoweredByAI from "@/components/cosec/PoweredByAI";
import RecordsFilings from "@/components/cosec/RecordsFilings";
import Compliance from "@/components/cosec/Compliance";
import Governance from "@/components/cosec/Governance";
import Security from "@/components/cosec/Security";
import Testimonials from "@/components/cosec/Testimonials";
import FinalCta from "@/components/cosec/FinalCta";
import FAQ from "@/components/cosec/FAQ";
import Footer from "@/components/cosec/Footer";
import StructuredData from "@/components/site/StructuredData";

const SITE_BASE = typeof window !== "undefined" ? window.location.origin : "";

const ORG_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "CoSec Global",
  url: SITE_BASE || "https://cosecglobal.com",
  logo: `${SITE_BASE}/favicon.ico`,
  sameAs: [
    "https://www.linkedin.com/company/cosecglobal",
    "https://x.com/cosecglobal",
    "https://www.facebook.com/cosecglobal",
    "https://www.youtube.com/@cosecglobal",
    "https://www.instagram.com/cosecglobal",
  ],
  contactPoint: [{
    "@type": "ContactPoint",
    telephone: "+44 330 133 2696",
    contactType: "sales",
    email: "contact@cosecglobal.com",
    areaServed: "GB",
    availableLanguage: ["English"],
  }],
};

const WEBSITE_LD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "CoSec Global",
  url: SITE_BASE || "https://cosecglobal.com",
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_BASE}/blog?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export default function CosecHome() {
  return (
    <main className="min-h-screen bg-background text-foreground">
      <StructuredData data={ORG_LD} id="ld-org" />
      <StructuredData data={WEBSITE_LD} id="ld-website" />
      <CosecHeader />
      <Hero />
      <ProductsPortfolio />
      <TrustedBy />
      <UnifiedPlatform />
      <PoweredByAI />
      <RecordsFilings />
      <Compliance />
      <Governance />
      <Security />
      <Testimonials />
      <FinalCta />
      <FAQ />
      <Footer />
    </main>
  );
}
